import { useOpenSearchKebabEvents } from 'hooks/events/useOpenSearchKebabEvents';
import { useOpenSearchContext } from 'hooks/useOpenSearchContext';
import { ButtonCustomProps } from 'open-search/types';
import { useTruckerNavigation } from 'hooks/useNavigation';
import { TextsSearchTrucker } from '../types';

export function useDownloadVerifiedProfile() {
  const { searchTruckerData } = useOpenSearchContext();

  const { handleNavigation } = useTruckerNavigation();

  const { sendKebabEvents } = useOpenSearchKebabEvents();

  const handleDownloadVerifiedProfile = () => {
    /* istanbul ignore else */
    if (searchTruckerData) {
      sendKebabEvents(searchTruckerData, 'trucker_search_driver_kebab_dowload_checkAi', 'download');
      handleNavigation(`/pre-consulta/${searchTruckerData?.trucker?.id}`);
    }
  };

  const propsDownloadVerifiedProfile: ButtonCustomProps = {
    states: { textContent: TextsSearchTrucker.textKebabDownloadVerifiedProfile },
    events: {
      onClick: () => handleDownloadVerifiedProfile(),
    },
  };

  return { propsDownloadVerifiedProfile };
}
